import React, { useEffect, useState } from "react";
import { ApiPromise, WsProvider } from "@polkadot/api";
import { encodeAddress } from "@polkadot/util-crypto";

const useConnectWs = () => {
  const [api, setApi] = useState(null);

  useEffect(() => {
    (async function () {
      const provider = new WsProvider(process.env.REACT_APP_RPC_URL);
      console.log("wss", process.env.REACT_APP_RPC_URL)
      const api = await ApiPromise.create({ provider });
      const [chain, nodeName, nodeVersion] = await Promise.all([
        api.rpc.system.chain(),
        api.rpc.system.name(),
        api.rpc.system.version(),
      ]);
      console.log(
        `You are connected to chain ${chain} using ${nodeName} v${nodeVersion}, genesisHash=${api.genesisHash.toHex()}`
      );
      setApi(api);

      // var result = await api.query.system.account.entries();
      // var address = encodeAddress(result[0][0].slice(-32))
      // var account = await api.query.system.account("5DSHtq9M7mbocvtgAhFVJna2uoD7XegKPwB1DkmjFyuqYFq1")
      // console.log(account.data.free.toString());
    })();
  }, []);

  return [api, setApi];
};

export default useConnectWs;
